/* eslint-disable @typescript-eslint/no-explicit-any */

export const ReactTableCell = ({ header, value, retailerList }: any) => {
  switch (header) {
    case "expression": {
      return <span className="flex items-center gap-1 flex-wrap">{value}</span>;
    }
    case "Result": {
      return <span className="flex items-center gap-1 flex-wrap">{value}</span>;
    }
    case "retailer_id": {
      const tempList: any = [];
      try {
        retailerList?.map((item: any) => {
          if (value?.includes(item?.retailer_id)) {
            tempList.push(item?.retailer_name);
          }
        });
      } catch (error) {
        console.log(error);
      }

      return (
        <span className="uppercase line-clamp-6 break-words">
          {tempList?.join(", ") || value}
        </span>
      );
    }
    default: {
      return <span>{value}</span>;
    }
  }
};
